// Our Components
import Modal from 'components/Modal/Modal';
import TradelineContent from 'components/Tradeline/TradelineContent';

function getClientName(queryResult, clientData) {
	if (queryResult?.clientName) return queryResult?.clientName;

	if (clientData?.firstName && clientData?.lastName)
		return `${clientData?.firstName} ${clientData?.lastName}`;

	if (clientData?.firstName) return clientData?.firstName;

	return 'Unknown';
}

function TradelineInfoModal({ isOpen, handleClose, queryResult, clientData }) {
	const { tradelineId } = queryResult;

	const clientName = getClientName(queryResult, clientData);

	return (
		<Modal
			isOpen={isOpen}
			handleClose={handleClose}
			title={`Wallet Data for client: ${clientName}`}
		>
			<TradelineContent tradelineId={tradelineId} />
		</Modal>
	);
}

export default TradelineInfoModal;
